import type { CSSProperties, ReactNode } from 'react';

export type PageTitleProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  /**
   * `plain` = só o h1 (visão geral, Finanças); `page` = `.pagehead` (transações, extrato, categorias, sync);
   * `checkout` = `.ck-head`; `integrations` = `.int-head`.
   */
  variant?: 'plain' | 'page' | 'checkout' | 'integrations';
  /** `lg` = título de 38px das telas com drawer. */
  size?: 'md' | 'lg';
  style?: CSSProperties;
};

/** Título da página com subtítulo e ações à direita. */
export function PageTitle({ title, subtitle, actions, variant = 'plain', size = 'md', style }: PageTitleProps) {
  const titleStyle = size === 'lg' ? { fontSize: 38 } : undefined;
  if (variant === 'plain') return <h1 className="title" style={{ ...titleStyle, ...style }}>{title}</h1>;
  if (variant === 'integrations') {
    return (
      <div className="int-head" style={style}>
        <div><h1>{title}</h1>{subtitle && <p>{subtitle}</p>}</div>
        {actions}
      </div>
    );
  }
  const h1 = <h1 className="title" style={titleStyle}>{title}</h1>;
  return (
    <div className={variant === 'checkout' ? 'ck-head' : 'pagehead'} style={style}>
      {subtitle ? <div>{h1}<p className="subtitle">{subtitle}</p></div> : h1}
      {actions}
    </div>
  );
}
